export const images2En = [
  {
    src: "/images/menu/en/5.jpg",
    original: "/images/menu/en/2.jpg",
    width: 300,
    height: 594,
    caption: "Culture Beat Menu Photo",
  },{
    src: "/images/menu/en/6.jpg",
    original: "/images/menu/en/3.jpg",
    width: 300,
    height: 594,
    caption: "Culture Beat Menu Photo",
  },{
    src: "/images/menu/en/7.jpg",
    original: "/images/menu/en/4.jpg",
    width: 300,
    height: 594,
    caption: "Culture Beat Menu Photo",
  },
];